
import React, { useState } from "react";
import FField from "./FField";

export default function FormModal({form, setForm, equipos, saveEq, updateEq, saveCl, updateCl, saveAv, proyecto}) {
  const tipo=form.tipo;
  const edit=form.edit||null;
  const [d,setD]=useState({
    nombre:edit?.nombre||"", lat:edit?.lat||form.lat||"", lng:edit?.lng||form.lng||"",
    configurado:edit?.configurado!=null?parseInt(edit.configurado):0,
    numeracion:edit?.numeracion||"",
    material:edit?.material||"cemento",
    tipo_energia:edit?.tipo_energia||"sin_energia",
    altura_metros:edit?.altura_metros!=null?parseFloat(edit.altura_metros):8,
    tiene_luz:edit?.tiene_luz!=null?parseInt(edit.tiene_luz):0,
    tiene_transformador:edit?.tiene_transformador!=null?parseInt(edit.tiene_transformador):0,
    retenciones:edit?.retenciones!=null?parseInt(edit.retenciones):0,
    cantidad_cables:edit?.cantidad_cables!=null?parseInt(edit.cantidad_cables):0,
    cantidad_dispositivos:edit?.cantidad_dispositivos!=null?parseInt(edit.cantidad_dispositivos):0,
    tipo_instalacion:edit?.tipo_instalacion||"aerea", estado:edit?.estado||"activo", notas:edit?.notas||"",
    olt_id:edit?.olt_id||"", mufa_id:edit?.mufa_id||"", poste_id:edit?.poste_id||form.poste_id||"",
    puertos:edit?.puertos||8, tipo_splitter:edit?.tipo_splitter||"1x8",
    marca:edit?.marca||"", modelo:edit?.modelo||"", puertos_pon:edit?.puertos_pon||8,
    num_slots:edit?.num_slots||1, puertos_por_slot:edit?.puertos_por_slot||8,
    tiene_odf:edit?.tiene_odf||0, puertos_odf:edit?.puertos_odf||0,
    tipo_hilos:edit?.tipo_hilos||"12", origen_id:edit?.origen_id||"olt-1",
    destino_tipo:edit?.destino_tipo||"mufa", destino_id:edit?.destino_id||"", longitud_metros:edit?.longitud_metros||"",
    nombre_cliente:edit?.nombre||"", cedula:edit?.cedula||"", telefono:edit?.telefono||"",
    email:edit?.email||"", direccion:edit?.direccion||"", puerto:edit?.puerto||"",
    nap_id:edit?.nap_id||form.nap?.id||"",
    titulo:"", descripcion:"",
    equipo_tipo:form.equipo?.tipo||"", equipo_id:form.equipo?.id||"",
    estado_cliente:edit?.estado||"en_instalacion",
  });
  const [err,setErr]=useState("");
  const [saving,setSaving]=useState(false);
  const [configurarPoste,setConfigurarPoste]=useState(!!edit);

  const upd=(k,v)=>setD(x=>({...x,[k]:v}));

  const submit=async()=>{
    setSaving(true); setErr("");
    let r;
    if(tipo==="cliente"){
      const payload={nombre:d.nombre_cliente,cedula:d.cedula,telefono:d.telefono,email:d.email,direccion:d.direccion,nap_id:d.nap_id,puerto:d.puerto,estado:d.estado_cliente,notas:d.notas};
      r=edit ? await updateCl({...payload,id:edit.id}) : await saveCl(payload);
    } else if(tipo==="averia"){
      r=await saveAv({titulo:d.titulo,equipo_tipo:d.equipo_tipo,equipo_id:d.equipo_id,descripcion:d.descripcion});
    } else if(tipo==="fibra"){
      const coords=form.coordenadas && form.coordenadas.length>0 ? JSON.stringify(form.coordenadas) : (edit?.coordenadas ? String(edit.coordenadas) : null);
      console.log('FORM COORDS:', form.coordenadas?.length, 'EDIT COORDS:', edit?.coordenadas?.substring?.(0,50));
      const p={...d, coordenadas:coords};
      if(form.origen){ p.origen_tipo=form.origen.tipo; p.origen_id=form.origen.id; }
      else if(!edit){ const pts=(d.origen_id+"").split("-"); p.origen_tipo=pts[0]; p.origen_id=parseInt(pts[1])||0; }
      if(form.destino){ p.destino_tipo=form.destino.tipo; p.destino_id=form.destino.id; }
      else if(!edit){ p.destino_id=parseInt(d.destino_id)||0; }    
	console.log("Enviando fibra:", JSON.stringify(p));
      const proy_id = proyecto ? proyecto.id : 1;
      r=edit ? await updateEq(tipo,{...p,id:edit.id}) : await saveEq(tipo,{...p,proyecto_id:proy_id});
    } else {
      const proy_id = proyecto ? proyecto.id : 1;
      r=edit ? await updateEq(tipo,{...d,id:edit.id}) : await saveEq(tipo,{...d,proyecto_id:proy_id});
    }
    setSaving(false);
    if(r&&!r.success) setErr(r.error||"Error al guardar");
  };

  const titles={olt:edit?"Editar OLT":"Nuevo OLT",mufa:edit?"Editar Mufa":"Nueva Mufa",nap:edit?"Editar NAP":"Nueva NAP",fibra:edit?"Editar Fibra":"Nueva Fibra",cliente:edit?"Editar Cliente":"Nuevo Cliente",averia:"Reportar Averia"};

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"flex-end",zIndex:300}}>
      <div style={{background:"#FFFFFF",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,margin:"0 auto",padding:"1.5rem",maxHeight:"85vh",overflowY:"auto"}}>
        <div style={{width:40,height:4,background:"#E8ECF0",borderRadius:99,margin:"0 auto 16px"}}/>
        <p style={{margin:"0 0 16px",fontWeight:600,fontSize:16}}>{titles[tipo]||tipo}</p>
        {(tipo==="olt"||tipo==="mufa"||tipo==="nap")&&<>
          <FField k="nombre" label="Nombre *" val={d.nombre} onChange={upd}/>
          {!edit&&<><FField k="lat" label="Latitud *" val={d.lat} onChange={upd}/><FField k="lng" label="Longitud *" val={d.lng} onChange={upd}/></>}
          <FField k="tipo_instalacion" label="Instalacion" val={d.tipo_instalacion} onChange={upd} opts={[{v:"aerea",l:"Aerea"},{v:"subterranea",l:"Subterranea"}]}/>
          <FField k="estado" label="Estado" val={d.estado} onChange={upd} opts={[{v:"activo",l:"Activo"},{v:"danado",l:"Danado"},{v:"mantenimiento",l:"Mantenimiento"}]}/>
        </>}
        {tipo==="olt"&&<>
          <FField k="marca" label="Marca" val={d.marca} onChange={upd} opts={[
            {v:"",l:"Selecciona marca..."},
            {v:"HUAWEI",l:"HUAWEI"},{v:"CDATA",l:"CDATA"},{v:"ZTE",l:"ZTE"},
            {v:"FIBERHOME",l:"FIBERHOME"},{v:"VSOL",l:"VSOL"},{v:"OTRA",l:"Otra marca"}
          ]}/>
          {d.marca==="HUAWEI"
            ? <FField k="modelo" label="Modelo" val={d.modelo} onChange={upd} opts={[{v:"MA5608T",l:"MA5608T"},{v:"MA5800-X2",l:"MA5800-X2"}]}/>
            : <FField k="modelo" label="Modelo" val={d.modelo} onChange={upd}/>
          }
          {d.marca==="OTRA"&&<FField k="marca_custom" label="Escribir marca" val={d.marca_custom||""} onChange={upd}/>}
          <div style={{display:"flex",gap:8}}>
            <div style={{flex:1}}><FField k="num_slots" label="Nº de slots" type="number" val={d.num_slots} onChange={upd}/></div>
            <div style={{flex:1}}><FField k="puertos_por_slot" label="Puertos por slot" val={d.puertos_por_slot} onChange={upd} opts={[{v:8,l:"8 puertos"},{v:16,l:"16 puertos"}]}/></div>
          </div>
          <div style={{background:"rgba(124,58,237,0.1)",border:"1px solid #7C3AED33",borderRadius:6,padding:"6px 10px",marginBottom:6}}>
            <p style={{margin:"0 0 4px",fontSize:11,color:"#C4B5FD",fontWeight:600}}>Vista previa — formato slot/puerto:</p>
            <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
              {Array.from({length:parseInt(d.num_slots)||1},(_,s)=>
                Array.from({length:parseInt(d.puertos_por_slot)||8},(_,p)=>(
                  <span key={s+"-"+p} style={{fontSize:9,color:"#7C3AED",background:"rgba(124,58,237,0.15)",padding:"1px 5px",borderRadius:3,border:"1px solid #7C3AED44"}}>
                    {s}/{p}
                  </span>
                ))
              )}
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
            <input type="checkbox" id="tiene_odf" checked={!!d.tiene_odf} onChange={e=>upd("tiene_odf",e.target.checked?1:0)} style={{cursor:"pointer"}}/>
            <label htmlFor="tiene_odf" style={{fontSize:12,color:"#9CA3AF",cursor:"pointer"}}>Tiene ODF</label>
          </div>
          {!!d.tiene_odf&&<FField k="puertos_odf" label="Puertos ODF" type="number" val={d.puertos_odf} onChange={upd}/>}
        </>}

        {tipo==="nap"&&<>
          <FField k="puertos" label="Puertos" val={d.puertos} onChange={upd} opts={[{v:8,l:"8 puertos"},{v:16,l:"16 puertos"}]}/>
          <FField k="tipo_splitter" label="Splitter" val={d.tipo_splitter} onChange={upd} opts={[{v:"1x8",l:"1x8"},{v:"1x16",l:"1x16"},{v:"1x32",l:"1x32"}]}/>
          <FField k="mufa_id" label="Mufa padre" val={d.mufa_id} onChange={upd} opts={[{v:"",l:"Sin mufa"},...(equipos.mufas||[]).map(m=>({v:m.id,l:m.nombre}))]}/>

        </>}
        {tipo==="poste"&&<>
          <FField k="nombre" label="Nombre/Referencia" val={d.nombre||""} onChange={upd}/>
          {!configurarPoste&&(
            <button onClick={()=>{setConfigurarPoste(true);upd("configurado",1);}} style={{width:"100%",padding:"10px",background:"#F59E0B",color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:10}}>
              ⚙️ Configurar poste
            </button>
          )}
          {configurarPoste&&<>
            <FField k="numeracion" label="Numeración física" val={d.numeracion||""} onChange={upd}/>
            <FField k="material" label="Material" val={d.material||"cemento"} onChange={upd} opts={[{v:"cemento",l:"Cemento"},{v:"metalico",l:"Metálico"}]}/>
            <FField k="tipo_energia" label="Tipo energía" val={d.tipo_energia||"sin_energia"} onChange={upd} opts={[{v:"sin_energia",l:"Sin energía"},{v:"baja_tension",l:"Baja tensión"},{v:"media_tension",l:"Media tensión"},{v:"media_baja_tension",l:"Media y baja"}]}/>
            <FField k="altura_metros" label="Altura (m)" val={String(d.altura_metros||8)} onChange={(k,v)=>upd(k,parseFloat(v))} opts={[{v:"8",l:"8m"},{v:"9",l:"9m"},{v:"10",l:"10m"},{v:"11",l:"11m"},{v:"12",l:"12m"},{v:"13",l:"13m"},{v:"14",l:"14m"},{v:"15",l:"15m"}]}/>
            <div style={{display:"flex",gap:8}}>
              <div style={{flex:1}}><FField k="tiene_luz" label="Iluminación" val={d.tiene_luz||0} onChange={upd} opts={[{v:0,l:"No"},{v:1,l:"Sí"}]}/></div>
              <div style={{flex:1}}><FField k="tiene_transformador" label="Transformador" val={d.tiene_transformador||0} onChange={upd} opts={[{v:0,l:"No"},{v:1,l:"Sí"}]}/></div>
            </div>
            <div style={{display:"flex",gap:8}}>
              <div style={{flex:1}}><FField k="retenciones" label="Retenciones" val={d.retenciones||0} onChange={upd} opts={[{v:0,l:"0"},{v:1,l:"1"},{v:2,l:"2"},{v:3,l:"3"}]}/></div>
              <div style={{flex:1}}><FField k="cantidad_cables" label="Cant. cables" type="number" val={d.cantidad_cables||0} onChange={upd}/></div>
            </div>
            <FField k="cantidad_dispositivos" label="Cant. dispositivos" type="number" val={d.cantidad_dispositivos||0} onChange={upd}/>
            <FField k="notas" label="Notas" val={d.notas||""} onChange={upd}/>
          </>}
        </>}
        {tipo==="reserva"&&<>
          <FField k="nombre" label="Referencia" val={d.nombre||""} onChange={upd}/>
          <FField k="metraje" label="Metros de reserva" type="number" val={d.metraje||0} onChange={upd}/>
          <FField k="notas" label="Notas" val={d.notas||""} onChange={upd}/>
          <p style={{fontSize:11,color:"#6B7280",margin:"4px 0"}}>La reserva se guardará en el punto del mapa donde fue colocada.</p>
        </>}
        {tipo==="fibra"&&<>
          <FField k="nombre" label="Nombre" val={d.nombre} onChange={upd}/>
          <FField k="tipo_hilos" label="Hilos" val={d.tipo_hilos} onChange={upd} opts={[{v:"6",l:"6 hilos"},{v:"12",l:"12 hilos"},{v:"24",l:"24 hilos"},{v:"48",l:"48 hilos"},{v:"96",l:"96 hilos"}]}/>
          <FField k="tipo_instalacion" label="Instalacion" val={d.tipo_instalacion} onChange={upd} opts={[{v:"aerea",l:"Aerea"},{v:"subterranea",l:"Subterranea"}]}/>
          {!edit&&<>
            <FField k="origen_id" label="Equipo origen" val={d.origen_id} onChange={upd} opts={[...(equipos.olts||[]).map(o=>({v:"olt-"+o.id,l:"OLT: "+o.nombre})),...(equipos.mufas||[]).map(m=>({v:"mufa-"+m.id,l:"Mufa: "+m.nombre})),...(equipos.naps||[]).map(n=>({v:"nap-"+n.id,l:"NAP: "+n.nombre}))]}/>
            <FField k="destino_tipo" label="Tipo destino" val={d.destino_tipo} onChange={upd} opts={[{v:"olt",l:"OLT"},{v:"mufa",l:"Mufa"},{v:"nap",l:"NAP"}]}/>
            <FField k="destino_id" label="Equipo destino" val={d.destino_id} onChange={upd} opts={[...(equipos.olts||[]).map(o=>({v:o.id,l:"OLT: "+o.nombre})),...(equipos.mufas||[]).map(m=>({v:m.id,l:"Mufa: "+m.nombre})),...(equipos.naps||[]).map(n=>({v:n.id,l:"NAP: "+n.nombre}))]}/>
          </>}
          <FField k="longitud_metros" label="Longitud metros" type="number" val={d.longitud_metros} onChange={upd}/>
          {edit&&<FField k="estado" label="Estado" val={d.estado} onChange={upd} opts={[{v:"activo",l:"Activo"},{v:"danado",l:"Danado"},{v:"cortado",l:"Cortado"}]}/>}
          {form.coordenadas&&<p style={{fontSize:12,color:"#10B981",margin:"0 0 12px"}}>Ruta dibujada: {form.coordenadas.length} puntos</p>}
        </>}
        {tipo==="cliente"&&<>
          <FField k="nombre_cliente" label="Nombre completo *" val={d.nombre_cliente} onChange={upd}/>
          <FField k="cedula" label="Cedula" val={d.cedula} onChange={upd}/>
          <FField k="telefono" label="Telefono" val={d.telefono} onChange={upd}/>
          <FField k="email" label="Email" val={d.email} onChange={upd}/>
          <FField k="direccion" label="Direccion" val={d.direccion} onChange={upd}/>
          <FField k="nap_id" label="Caja NAP" val={d.nap_id} onChange={upd} opts={[{v:"",l:"Sin NAP"},...(equipos.naps||[]).map(n=>({v:n.id,l:n.nombre}))]}/>
          <FField k="puerto" label="Puerto #" type="number" val={d.puerto} onChange={upd}/>
          <FField k="estado_cliente" label="Estado" val={d.estado_cliente} onChange={upd} opts={[{v:"activo",l:"Activo"},{v:"inactivo",l:"Inactivo"},{v:"suspendido",l:"Suspendido"},{v:"en_instalacion",l:"En instalacion"}]}/>
        </>}
        {tipo==="averia"&&<>
          <FField k="titulo" label="Titulo *" val={d.titulo} onChange={upd}/>
          <FField k="equipo_tipo" label="Tipo equipo" val={d.equipo_tipo} onChange={upd} opts={[{v:"olt",l:"OLT"},{v:"mufa",l:"Mufa"},{v:"nap",l:"NAP"},{v:"fibra",l:"Fibra"}]}/>
          <FField k="equipo_id" label="Equipo afectado" val={d.equipo_id} onChange={upd} opts={[...(equipos.olts||[]).map(o=>({v:o.id,l:"OLT: "+o.nombre})),...(equipos.mufas||[]).map(m=>({v:m.id,l:"Mufa: "+m.nombre})),...(equipos.naps||[]).map(n=>({v:n.id,l:"NAP: "+n.nombre}))]}/>
          <FField k="descripcion" label="Descripcion" val={d.descripcion} onChange={upd}/>
        </>}
        <FField k="notas" label="Notas" val={d.notas} onChange={upd}/>
        {err&&<p style={{color:"#E53E3E",fontSize:13,margin:"0 0 10px"}}>{err}</p>}
        <div style={{display:"flex",gap:8}}>
          <button onClick={submit} disabled={saving} style={{flex:1,padding:"12px 0",background:"#1E7BBF",color:"#ffffff",border:"none",borderRadius:10,fontSize:14,fontWeight:600,cursor:"pointer"}}>{saving?"Guardando...":"Guardar"}</button>
          <button onClick={()=>setForm(null)} style={{flex:1,padding:"12px 0",background:"#F5F7FA",color:"#2C2C2C",border:"1px solid #E8ECF0",borderRadius:10,fontSize:14,cursor:"pointer"}}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
